module.exports = __webpack_public_path__ + "static/fanta-1-bfd8d7066b4f7bbc327d9fc193c6b8c8.jpg";